export const APP_CART_DATA_KEY = 'cart_data';

export const ASYNC_KEY_PLANS = 'plans';

export const ASYNC_KEY_PHONE_LISTING = 'mobiltelefoner_index';
export const ASYNC_KEY_FAMILY_PLANS_LISTING = 'familyplans_index';
export const ASYNC_KEY_TRADE_IN_PAGE = 'byt-in_index';
export const ASYNC_KEY_STUDENT_LISTING = 'student_index';
export const ASYNC_KEY_PREOWNED_LISTING = 'preowned_index';
export const ASYNC_KEY_ACCESSORIES_LISTING = 'accessories_index';
export const ASYNC_KEY_PREPAID_LISTING = 'kontantkort_index';
export const ASYNC_KEY_SUBSCRIPTION_PAGE = 'mobilabonnemang_index';

export const ASYNC_KEY_TEST_PERSONA_SAMPLES = 'testpersonasamples';

export const PDP_CACHE_KEY_PREFIXES = [
  '/mobiltelefoner/',
  '/tillbehor/',
] as const;

export const COUPON_AFFECTED_STATIC_CACHE_KEYS = [
  ASYNC_KEY_PHONE_LISTING,
  ASYNC_KEY_PREOWNED_LISTING,
  ASYNC_KEY_STUDENT_LISTING,
  ASYNC_KEY_ACCESSORIES_LISTING,
  ASYNC_KEY_FAMILY_PLANS_LISTING,
  ASYNC_KEY_PREPAID_LISTING,
  ASYNC_KEY_SUBSCRIPTION_PAGE,
] as const;
